import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BinarySelect, BinarySelectCommonDefaultProps } from "../../binary-select/BinarySelect";
// Delegate to the common component of Radio and Checkbox -- BinarySelect
export const Checkbox = forwardRef((props, ref) => (_jsx(BinarySelect, { ref: ref, isRadio: false, "data-testid": "Checkbox", ...props })));
Checkbox.displayName = "Checkbox";
Checkbox.defaultProps = BinarySelectCommonDefaultProps;
